import React, {Component} from "react";
import {DatePicker, message, Select, Modal} from "antd";
import moment from "moment-timezone";
import {isEmpty, map} from 'lodash';
import * as yup from "yup";

import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";
import Loader from "../../../../Common/Component/Loader";
import DefineLocation from "../Service/Proposal/DefineLocation";
import {EnvironmentOutlined} from "@ant-design/icons";

const {Option} = Select;

class RequestRepair extends Component {
  state = {
    product: '',
    description: '',
    date: '',
    amount: '',
    btn_active: false,
    locations: [],
    showLocation: false,
    mapZoom: 8
  }

  componentDidMount = () => {
    const {service} = this.props;
    let _markers = [], multiple_locations = service?.commercial_detail?.multiple_locations, address = service?.service_address
    if (multiple_locations && multiple_locations !== "None") {
      let locations = multiple_locations?.split('MULTIPOINT')[1]
      locations = locations?.trim().substr(1, locations.trim().length - 2)
      let temp = locations?.split(', ')
      map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
    } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
      _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
    }

    this.setState({locations: _markers})
  }

  onMarkerAdd = (obj) => {
    const {locations} = this.state;
    locations.push(obj)
    this.setState({locations})
  }

  UNSAFE_componentWillReceiveProps = () => {
    // message.destroy();
    this.setState({ loader: false });
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.validate())
  }

  // on clear
  onClear = () => {
    this.setState({
      product: '',
      description: '',
      date: '',
      amount: ''
    }, () => this.validate())
  }

  // To toggle location modal
  toggleLocation = () => {
    this.setState((prevState) => ({ showLocation: !prevState.showLocation }))
  }

  // store drop pins
  onSaveMarkers = (markers) => {
    this.setState({locations: markers})
  }

  // validate required fields
  validate = () => {
    const {product, description, date, amount} = this.state;

    const schema = yup.object().shape({
      product: yup.string().required('Product is required'),
      description: yup.string().required('Description is required'),
      date: yup.string().required('Date is required'),
      amount: yup.string().required('Amount is required')
    });

    const data = {product, description, date, amount};

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({btn_active: true})
      }).catch(() => {
        this.setState({btn_active: false})
      });
    }, 500)
  }

  // on repair service
  onRepairService = () => {
    const {requestRepairService, service, closeModal} = this.props;
    const {product, description, date, amount, locations} = this.state;
    let location_str = [];
    map(locations, (obj) => location_str.push(`${obj.lat}, ${obj.lng}`))
    this.setState({loader: true})
    let obj = {
      service_order_uuid: service?.uuid,
      product,
      description,
      date_needed_by: date ? moment(date).format('YYYY-MM-DD') : '',
      amount
    }
    if (!isEmpty(location_str)) {
      Object.assign(obj, {locations: location_str})
    }
    requestRepairService(obj)
    setTimeout(() => {
      closeModal()
      this.props.viewService({ service_order__uuid: service?.uuid, limit: 10, offset: 0 });
    }, 1000)
  }

  render() {
    const {visible, closeModal, service} = this.props;
    const {product, description, date, amount, btn_active, locations, loader, showLocation, mapZoom} = this.state;

    return (
      <Modal
        title="Request A Repair"
        visible={visible}
        onCancel={() => {closeModal(); this.onClear()}}
        footer={[
          <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => {closeModal(); this.onClear()}}>Cancel</button>,
          <button key="upload" className={`btn ${btn_active ? 'btn-warning' : 'disabled'}`} onClick={() => this.onRepairService()}>
            Request Repair</button>,
        ]}
      >
        {loader && <Loader />}
        <div className="fitem  half-fitem mt-20">
          <label style={{ color: "#444" }}><b>Product</b></label>
          <div>
            <Select
              placeholder="Please Select"
              showArrow
              virtual={false}
              style={{ width: '100%' }}
              value={product}
              className="from-control"
              onChange={(e) => this.onTextChange({target: {name: 'product', value: e}}) }>
              <Option value="pet_waste_stations">Pet Waste Stations</Option>
              <Option value="pet_waste_station_bags">Pet Waste Station Bags</Option>
              <Option value="pet_waste_station_service">Pet Waste Station Service</Option>
              <Option value="common_area_cleaning">Common Area Cleaning</Option>
              <Option value="trash_can_service">Trash Can Service</Option>
            </Select>
          </div>
        </div>
        <div className="fitem half-fitem mt-10">
          <label style={{ color: "#444" }}><b>Description</b></label>
          <textarea
            rows="3"           
            name="description"
            placeholder={"Add you description here"}
            value={description}
            onChange={(e) => this.onTextChange(e)} />
        </div>
        <div className="mt-10 flex">
          <div className="fitem  half-fitem" style={{ marginRight: "10px" }}>
            <label style={{ color: "#444" }}><b>Date Needed By</b></label>
            <DatePicker
              inputReadOnly
              disabledDate={(current) => current && current <= moment()}
              style={{ 'width': '100%' }}
              name='date'
              format="MM/DD/YYYY"
              allowClear={false}
              value={date}
              onChange={(e) => this.onTextChange({target: {name: 'date', value: e}})}              
            />
          </div>
          <div className="fitem  half-fitem">
            <label style={{ color: "#444" }}><b>Amount</b></label>
            <div style={{"position": "relative"}}>
              <span style={{
                "position": "absolute",
                "left": "5px",
                "top": "10px",
                "color": "gray"
              }}>$</span>
              <input
                type="text"
                value={amount}
                name="amount"
                onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e) }
                placeholder="0.00"
              />
            </div>
          </div>
        </div>
        <div className="fitem mt-20 half-fitem">
          <label style={{ color: "#444" }}><b>Location</b></label>
        </div>
        <div id={'org-map'} className="bdr-wrap mt-0" onClick={() => this.toggleLocation()} style={{'justifyContent': !isEmpty(locations) ? 'flex-start' : 'center'}}>
          {
            (!isEmpty(locations) && !showLocation ) ?
              <div className='map' style={{'justifyContent': 'center', 'alignItems': 'center', 'height': '100%', 'display': 'flex', 'flexDirection': 'column'}}>
                <CustomMap zoom={mapZoom} markers={locations} containerStyle={{width: '400px', height: '200px'}} />
              </div> : <div style={{'justifyContent': 'center', 'alignItems': 'center', 'display': 'flex', 'flexDirection': 'column'}}>
                <EnvironmentOutlined />
                <h3>Locations</h3>
                <p>Click  to add locations.</p>
              </div>
          }
        </div>

        {showLocation && <DefineLocation
          zoom={mapZoom}
          visible={showLocation}
          quoteDetail={service}
          onCancel={() => this.toggleLocation()}
          onSave={(markers, mapZoom) => {this.onSaveMarkers(markers); this.setState({mapZoom})}}
          markerList={!isEmpty(locations) ? locations : []} />}
      </Modal>
    );
  }
}

export default RequestRepair;